export default "__VITE_ASSET__1UEh8pax__"